export const DATE_FORMAT = 'YYYY/MM/DD'

/**
 * The marketing site's author landing page. It was the site root until the root was pointed at the
 * reviewer app's review-copies list [sc-28009]; the reviewer app links a signed-out visitor across to
 * it, and the website routes it through WebsitePaths.authors.
 */
export const WEBSITE_AUTHORS_PATH = '/authors'

/**
 * The marketing site's legal pages. The website routes them through WebsitePaths, and the author and
 * reader apps' footer links across to them [sc-29060].
 */
export const WEBSITE_LEGAL_PATHS = {
  terms: '/terms-and-conditions',
  privacyPolicy: '/privacy-policy',
  cookiePolicy: '/cookie-policy',
  affiliateDisclosure: '/affiliate-disclosure'
} as const

/** The reader app's store listings: the website's download links and the reader app's footer [sc-29060]. */
export const APP_STORE_LINKS = {
  apple: 'https://apps.apple.com/gb/app/booksprout/id1590873280',
  googlePlay: 'https://play.google.com/store/apps/details?id=co.booksprout.reviewer',
  amazon: 'https://www.amazon.co.uk/Booksprout-Web-Services-Inc/dp/B0B1QKDW21'
} as const

/** Booksprout's social profiles, in the order both footers show them [sc-29060]. */
export const SOCIAL_LINKS = {
  tiktok: 'https://www.tiktok.com/@booksproutapp',
  instagram: 'https://www.instagram.com/booksprout/',
  facebook: 'https://www.facebook.com/booksprout',
  x: 'https://x.com/booksprout'
} as const
